<template>
  <div class="home">
      <LoginLogout/>

      <!--
      <div v-if="!$auth.isAuthenticated" style="text-align: center">
        <p>Waiting for authorization</p>
      </div>
      -->
      <div v-if="!$auth.loading && !$auth.isAuthenticated && !loadedOtt" style="text-align: center">
        <h1 style="padding-top:3cm;"><img src="../assets/Staffan.jpg" style="border-radius: 25px; vertical-align: middle; width: 50px" /> {{ title }}</h1>
        <p><b-link @click="login">Logga in</b-link> eller registrera dig för att se arkivet</p>
        <img alt="Vue logo" src="../assets/logo.jpg" width=100%>
      </div>

      <!--
      	Exempel på format för "One time token"-access:
      	https://localhost:8081/video-streamer-develop/?ott=<ott>
      	-->

    <div v-if="!$auth.loading && ($auth.isAuthenticated || loadedOtt)">
      <StartFolders v-bind:ott="$route.query.ott"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginLogout from '@/components/LoginLogout.vue'
import StartFolders from '@/components/StartFolders.vue'

export default {
  name: 'Home',
  components: {
    LoginLogout,
    StartFolders
  },
  data() {
            return {
                title: process.env.VUE_APP_TITLE,
                loadedOtt: null
            }
  },
  /*
    *  Method that is called right after an instance has been created.
    */
  created() {
    const queryString = window.location.search;
    console.log(queryString);
    const urlParams = new URLSearchParams(queryString);
    this.loadedOtt = urlParams.get('ott');      
  },
  methods: {
      // Log the user in
      async login() {
          this.$auth.loginWithRedirect();
      }
  }
}
</script>
